import { when } from "hooks/useWhen";
import { PAYMENT_ARGS } from "consts/feature-config";

export const calculateEstimate = (weight, existingGiftRatio) => {
  const showPayment = when(PAYMENT_ARGS);
  const giftRatio = existingGiftRatio || 4;
  const paymentRatio = showPayment ? 3.6 : 2.4;
  let payment, gift;

  payment = (weight * paymentRatio).toFixed(2);
  gift = (weight * giftRatio).toFixed(2);
  return { gift, payment, giftRatio };
};
